import { getCurrentCustomerId } from '../../../auth/uip/utilities';
import { CustomerBasketsResponse } from '../../models/customer-baskets-response';
import { SFCCBasket } from '../../models/sfcc-basket';
import { addLocaleToBasketUrl } from '../../utilities/add-locale-to-basket-url';
import { sfccSettings, shopHttp } from '../basket-api';

export const getCurrentCustomerBaskets = async (): Promise<SFCCBasket[]> => {
  const customerId = await getCurrentCustomerId();
  if (!customerId) return [];

  const url = `/customers/${customerId}/baskets`;
  const finalUrl = addLocaleToBasketUrl(url, sfccSettings.shopApiLocale);
  const response = await shopHttp.get<CustomerBasketsResponse>(finalUrl);

  return response.data?.baskets || [];
};
